import * as React from 'react';
import { AuthState } from '../types/AuthState';

export const AuthContext = React.createContext<AuthState<any>>({
  isLoggedIn: false,
  data: undefined,
  login: _ => {},
  logout: () => {},
});
